import { Dayjs } from 'dayjs';

export const isWeekend = (date: Dayjs) => {
  const day = date.day();
  return day === 0 || day === 6;
};
